module.exports = __webpack_public_path__ + "static/media/s_cur_02.065f8a5a.png";